/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { defineComponent } from "vue";

export interface IFlowPanelContent {
  save(flowId: string, params?: ISaveParams): void;
}

export interface ISaveParams {
  name: string;
  description?: string;
}

export default defineComponent({
  name: "FlowPanelContentMixin",
  emits: ["overlay", "close", "loading", "update:data"],
  methods: {
    save(flowId: string, params?: ISaveParams) {
      // Implemented in component
    },
  },
});
